import React from 'react'
import { ClipLoader } from 'react-spinners';
import {css} from "@emotion/react";
import {  useSelector } from "react-redux";

const Loader = ({size}) => {
  const { bgColor, textColor } = useSelector((state) => state.theam);

    let color = `#${bgColor}`;
    const override = css`   
      borderColor: "red",
    `;
  return (<ClipLoader
  className='centerlo'
        color={color}
        loading={true}
        cssOverride={override}
        size={size ? size : 80}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
  )
}

export default Loader